export default "__VITE_ASSET__DaSHDOvx__"